module.exports = __webpack_public_path__ + "img/pr-2.9fc5344a.png";